import { render, staticRenderFns } from "./vital_signs_family.vue?vue&type=template&id=01241624"
import script from "./vital_signs_family.vue?vue&type=script&lang=js"
export * from "./vital_signs_family.vue?vue&type=script&lang=js"
import style0 from "./vital_signs_family.vue?vue&type=style&index=0&id=01241624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports